define('SageDotCom/DataLayer/Events/ga4-video-interaction',[
    "SageDotCom/DataLayer/Events/eventBase"
], function (eventBase) {

    function ga4VideoInteractionEvent(player, isMilestoneEvent, isSeekEvent, isVideoStartEvent) {
        eventBase.call(this);

        if (player.isYoutube) {
            this.props = {
                "event": "video",
                "video_status": isMilestoneEvent ? "milestone" : getYouTubeStateLabel(player, isSeekEvent, isVideoStartEvent),
                "video_title": player.getVideoData().title,
                "video_id": player.getVideoData().video_id,
                "video_provider": "youtube",
                "video_duration": Math.floor(player.getDuration()).toString(),
                "video_current_time": Math.floor(player.getCurrentTime()).toString(),
                "milestone_in_%": getMilestoneInPercent(player),
                "display_method": "embeded"
            };
        }
        else {
            //must be brightcove
            this.props = {
                "event": "video",
                "video_status": getBrightcoveStateLabel(player),
                "video_title": player.videoTitle,
                "video_id": player.videoId,
                "video_provider": "brightcove",
                "video_duration": player.duration.toString(),
                "video_current_time": player.currentTime.toString(),
                "milestone_in_%": player.milestone.toString(),
                "display_method": "embeded"
            };
        }
    }

    ga4VideoInteractionEvent.prototype = Object.create(eventBase.prototype);

    function getBrightcoveStateLabel(player) {
        switch (player.eventType) {
            case "play":
                return "play";
            case "pause":
                return "pause";
            case "ended":
                return "end";
            case "seeked":
                return "seek";
            case "milestone":
                return "milestone";
            case "firstplay":
                return "video_start";
            default:
                return "(not set)";
        }
    }

    function getYouTubeStateLabel(player, isSeekEvent, isVideoStartEvent) {
        if (isVideoStartEvent) {
            return "video_start";
        }
        if (isSeekEvent) {
            return "seek";
        }
        switch (player.getPlayerState()) {
            case YT.PlayerState.PLAYING:
                return "play";
            case YT.PlayerState.PAUSED:
                return "pause";
            case YT.PlayerState.ENDED:
                return "end";
            default:
                return "(not set)";
        }
    }

    function getMilestoneInPercent(player) {
        if (player.getPlayerState && player.getPlayerState() == YT.PlayerState.ENDED) {
            return "100";
        }
        return (player.tracking.ga4MilestonesDecimalValues[player.tracking.ga4Milestone] * 100).toString();
    }

    return ga4VideoInteractionEvent;
});
